<template>
  <div
    id="product-item"
    :class="{'hoverable': hoverable, 'with-shadow': shadow, 'selected': selected, 'padding-item': paddingItem}"
    :style="`opacity: ${opacity}`"
  >
    <b-media
      vertical-align="center"
    >
      <template #aside>
        <b-img
          rounded
          class="product-info__image"
          :src="linkStaging(img, imgSize, imgSize)"
          alt=""
          :width="imgSize"
          @error="(event) => {
            event.target.src = require('@/assets/images/icons/broken-image.svg')
          }"
        /></template>
      <span class="font-weight-bold d-block">
        <span
          :class="{ 'clamp': clamp }"
          :style="`font-size: ${titleSize}; ${clamp ? `-webkit-line-clamp: ${clamp};` : ''}`"
        >{{ title }}</span>
        <b-badge
          v-if="badge"
          :variant="badgeData[0]"
        >
          {{ badgeData[1] }}
        </b-badge>
      </span>
      <small v-if="subtitle">{{ subtitle }}</small>
      <span v-if="variantData">
        <br v-if="subtitle">
        <small class="text-muted">{{ variantData }}</small>
      </span>
      <span v-if="price">
        <br v-if="subtitle">
        <small class="text-muted">{{ price }}</small>
      </span>
    </b-media>
    <span v-if="isLoading">
      <b-spinner
        variant="primary"
        small
      />
    </span>
  </div>
</template>

<script>
import {
  BMedia,
  BBadge,
  BImg,
  BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BMedia,
    BBadge,
    BImg,
    BSpinner,
  },
  props: {
    img: {
      type: String,
      default: '',
    },
    imgSize: {
      type: String,
      default: '50',
    },
    title: {
      type: String,
      default: '',
    },
    titleSize: {
      type: String,
      default: '1rem',
    },
    subtitle: {
      type: String,
      default: '',
    },
    badge: {
      type: String,
      default: '',
    },
    price: {
      type: String,
      default: '',
    },
    hoverable: {
      type: Boolean,
      default: false,
    },
    opacity: {
      type: Number,
      default: 1,
    },
    clamp: {
      type: Number,
      default: 0,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    variantData: {
      type: String,
      default: '',
    },
    paddingItem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    badgeData() {
      let data = ''
      if (this.badge) data = this.badge.split('|')
      return data
    },
  },
  methods: {
    startLoading() {
      this.isLoading = true
    },
    endLoading() {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.dark-layout {
  #product-item {
    &.with-shadow {
      background-color: #283046;
    }

    &.selected {
      background-color: rgba(40,199,111,.12);
      border: 1px solid #28c76f;
    }
  }
}

#product-item {
  display: flex;
  justify-content: space-between;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;

    .clamp {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    &.hoverable {
        transition: 0.2s all;
        cursor: pointer;

        &:hover {
            background: rgba(115,103,240,.12);
            border-radius: 4px;
            padding-left: 0.5rem;
        }

        &.with-shadow {
          &:hover {
            background: rgba(115,103,240,.12);
            border-radius: 4px;
            padding-left: 1rem;
          }
        }
    }

    &.with-shadow {
      background-color: #fff;
      border-radius: 0.357rem;
      padding: 0.75rem;
    }

    &.selected {
      background-color: rgba(40,199,111,.12);
      border: 1px solid #28c76f;

      &.padding-item {
        padding-left: 0.5rem;
      }
    }
}
</style>
